/* eslint-disable simple-import-sort/imports */
import PropTypes from 'prop-types';
import React from 'react';

import {
  CardContainer,
  CardContentWrapper,
  CardDescription,
  CardHeaderWrapper,
  CardIcon,
  CardIconsWrapper,
  CardImage,
  CardImageWrapper,
  CardInfoWrapper,
  CardName,
  CardRole,
  CardTitle,
  FlipCardBack,
  FlipCardFront,
  FlipCardInner,
} from './styles';

const Card = ({ variant, data, isFlipped, onCardClick }) => {
  if (variant === 'testimonial') {
    return (
      <CardContainer $variant="testimonial">
        <CardContentWrapper>
          <CardHeaderWrapper>
            <CardImageWrapper>
              <CardImage src={data.image} alt={data.name} />
            </CardImageWrapper>
            <CardInfoWrapper>
              <CardName>{data.name}</CardName>
              <CardRole>{data.role}</CardRole>
            </CardInfoWrapper>
          </CardHeaderWrapper>
          <CardDescription>{`"${data.description}"`}</CardDescription>
        </CardContentWrapper>
      </CardContainer>
    );
  }

  if (variant === 'tip') {
    return (
      <CardContainer
        $variant="tip"
        onClick={onCardClick}
        $isFlipped={isFlipped}
      >
        <FlipCardInner className={`flip-inner ${isFlipped ? 'flipped' : ''}`}>
          <FlipCardFront>
            <CardIconsWrapper>
              <CardIcon src={data.icon} alt={'icon'} />
            </CardIconsWrapper>
            <CardTitle>{data.title}</CardTitle>
          </FlipCardFront>
          <FlipCardBack>
            <CardDescription style={{ textAlign: 'center', fontSize: '15px' }}>
              {data.details}
            </CardDescription>
          </FlipCardBack>
        </FlipCardInner>
      </CardContainer>
    );
  }

  return null;
};

Card.propTypes = {
  variant: PropTypes.oneOf(['tip', 'testimonial']).isRequired,
  data: PropTypes.object.isRequired,
  isFlipped: PropTypes.bool,
  onCardClick: PropTypes.func,
};

export default Card;
